'use client';

import { useState, useCallback, useRef } from 'react';
import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { toast } from 'sonner';

let refreshPromise = null;

async function tryRefresh() {
  if (refreshPromise) return refreshPromise;
  refreshPromise = fetch('/api/auth/refresh', { method: 'POST' })
    .then((r) => r.ok)
    .catch(() => false)
    .finally(() => { refreshPromise = null; });
  return refreshPromise;
}

const QueryProvider = ({ children }) => {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            retry: (failureCount, error) => {
              if (error?.status === 401 && failureCount === 0) return true;
              return false;
            },
            retryDelay: async (_, error) => {
              if (error?.status === 401) {
                const ok = await tryRefresh();
                if (!ok) window.location.href = '/login';
                return 0;
              }
              return 1000;
            },
          },
        },
        queryCache: new QueryCache({
          onError: (error, query) => {
            if (error?.status === 401 || query?.meta?.silent) return;
            const message =
              error.message || 'Something went wrong. Please try again.';
            toast.error(message);
          },
        }),
      }),
  );

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};

export { QueryProvider };
